'use strict';

var toString = Object.prototype.toString

  , id = toString.call('');

module.exports = function (x) {
	return (typeof x === 'string') || (x && (typeof x === 'object') &&
		((x instanceof String) || (toString.call(x) === id))) || false;
};



//////////////////
// WEBPACK FOOTER
// ../~/es5-ext/string/is-string.js
// module id = 54
// module chunks = 0